import request from '@/utils/request'


//查询
export function fechListReleaseLesson(data) {
  return request({
    url: '/admin/releaselesson/qlLessons',
    method: 'post',
    data: data
  })
}

//查询包含预约信息的
export function fechListReleaseLessonDetail(data) {
  return request({
    url: '/admin/releaselesson/qlLessonsDetail',
    method: 'post',
    data: data
  })
}

//发布模板课程
export function releaseWeekLesson(params) {
  return request({
    url: '/admin/releaselesson/releaseWeekLesson',
    method: 'get',
    params: params
  })
}
//查询A排课业务
export function lessonsCourseArranging(params) {
  return request({
    url: '/admin/lessonsCourseArranging/list',
    method: 'get',
    params: params
  })
}
//查询A排课业务
export function listByStoreFontId(params) {
  return request({
    url: '/admin/lessonsCourseArranging/listByStoreFontId',
    method: 'get',
    params: params
  })
}
//发布
export function releaseLesson(data) {
  return request({
    url: '/admin/releaselesson/releaseLesson',
    method: 'post',
    data: data
  })
}
//A排课时间保存
export function lessonsCourseAdd(data) {
  return request({
    url: '/admin/lessonsCourseArranging/add',
    method: 'post',
    data: data
  })
}
//撤销
export function revokeLesson(params) {
  return request({
    url: '/admin/releaselesson/revokeLesson',
    method: 'get',
    params: params
  })
}
//取消撤销
export function inUseLesson(params) {
  return request({
    url: '/admin/releaselesson/inUseLesson',
    method: 'get',
    params: params
  })
}
//删除
export function delLesson(params) {
  return request({
    url: '/admin/releaselesson/delLesson',
    method: 'get',
    params: params
  })
}

//发布一周的基础游课程
export function releaseBsWeekLesson(params) {
  return request({
    url: '/admin/releaselesson/releaseBsWeekLesson',
    method: 'get',
    params: params
  })
}


//查询一天的
export function qlDayReleaseLessons(params) {
  return request({
    url: '/admin/releaselesson/qlDayReleaseLessons',
    method: 'get',
    params: params
  })
}

//查询一周的
export function qlWeekReleaseLessons(params) {
  return request({
    url: '/admin/releaselesson/qlWeekReleaseLessons',
    method: 'get',
    params: params
  })
}


//修改课程信息
export function updateReleaseLessonInfo(data) {
  return request({
    url: '/admin/releaselesson/updateReleaseLessonInfo',
    method: 'post',
    data: data
  })
}
//修改基础课程信息
export function updateOneBsLesson(data) {
  return request({
    url: '/admin/releaselesson/updateOneBsLesson',
    method: 'post',
    data: data
  })
}


//校准课程
export function correctBookNum(params) {
  return request({
    url: '/admin/releaselesson/correctBookNum',
    method: 'get',
    params: params
  })
}



//查询课程配置
export function lessonsGET(params) {
  return request({
    url: '/admin/lessons/config',
    method: 'get',
    params: params
  })
}




// WEBPACK FOOTER //
// ./src/api/StoreReleaseLesson.js